import { useState } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(`${base_url}api/auth/login`, {
        email,
        password,
      });
      setLoading(false);
      return res.data;
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || 'Login failed');
      return null;
    }
  };

  return { login, loading, error };
};

export default useAuth;

